module.exports = __webpack_public_path__ + "static/media/vspacefloor.c7055afa.png";